<template>
  <svg class="app-shape">
    <polygon :points="points" />
  </svg>
</template>

<script>
export default {
  name: "AppShape",
  props: {
    points: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.app-shape {
  fill: colors(palette-3);
}
</style>
